import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountDuplicateStatus as GetAccountDuplicateStatusQuery,
    GetAccountDuplicateStatusVariables,
    AccountDuplicateFragment,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_DUPLICATE_STATUS from '../queries/get-account-duplicate-status.graphql';

export function useGetAccountDuplicateStatus(accountId: string): {
    accountDuplicateStatus: AccountDuplicateFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetAccountDuplicateStatusQuery,
        GetAccountDuplicateStatusVariables
    >(GET_ACCOUNT_DUPLICATE_STATUS, {
        variables: {id: accountId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    return {
        accountDuplicateStatus: data?.account ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
